import { DeleteOutlined } from '@ant-design/icons';
import { Button, Drawer, Form, message } from 'antd';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useToggle } from 'react-use';

import { toggleCart, updateCartCount } from '../../actions/CartAction';
import useTable from '../../components/Template/TableTemplate';
import { fetchAPI } from '../../utils/api';
import useWindowDimension from '../../utils/useWindowDimension';
import OrderCreate from '../Order/OrderCreate';
import { formatOrder } from '../Order/utils';

export default () => {
  const dispatch = useDispatch();
  const { isSmallScreen } = useWindowDimension();

  const [table, toggleLoad] = useTable({
    paginationPosition: 'bottom',
    showDateRange: false,
    showDownload: false,
    showSearch: false,
    showPagination: false,
    url: 'cart/list',
    method: 'POST',
    rowSelectionProps: {
      selectedRowKey: 'is_selected',
      onChange: async (dataSource, selectedRowKeys, selectedRows) => {
        await fetchAPI('cart/items', {
          payload: {
            items: dataSource.map(item => ({
              id: item.id,
              is_selected: selectedRowKeys.includes(String(item.id)),
            })),
          },
          method: 'PATCH',
        });
        toggleLoad();
      },
    },
    columns: [
      {
        title: 'Product Name',
        dataIndex: 'name',
        width: 200,
      },
      {
        title: 'Quantity',
        dataIndex: 'quantity',
        width: 50,
        onCell: record => ({
          record,
          editable: true,
          dataIndex: 'quantity',
          title: 'Quantity',
          handleSave: async ({ id, quantity }) => {
            await fetchAPI('cart/items', {
              payload: { items: [{ id, quantity }] },
              method: 'PATCH',
            });
            toggleLoad();
          },
        }),
      },
      {
        title: 'Price',
        dataIndex: 'price',
        width: 50,
      },
      {
        title: 'Total',
        dataIndex: 'total',
        width: 100,
      },
      {
        title: 'Action',
        render: (record: Product) => (
          <Button
            shape="circle"
            icon={<DeleteOutlined />}
            onClick={async () => {
              await fetchAPI(`cart/items/delete`, {
                payload: {
                  item_ids: [record.id],
                },
                method: 'POST',
              });
              toggleLoad();
            }}
          />
        ),
        width: 50,
      },
    ],
  });
  const [orderVisible, toggleOrder] = useToggle(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [form] = Form.useForm();
  return (
    <div>
      <Drawer
        visible
        title={
          <div>
            <span>Cart</span>
            <span style={{ float: 'right' }}>
              {orderVisible ? (
                <div>
                  <Button
                    style={{ marginRight: 20 }}
                    onClick={() => {
                      toggleOrder();
                    }}
                  >
                    Back
                  </Button>
                  <Button onClick={form.submit} type="primary">
                    Save Order
                  </Button>
                </div>
              ) : (
                <Button
                  onClick={async () => {
                    const { items } = await fetchAPI('cart/list', {
                      payload: {
                        is_selected: true,
                      },
                      method: 'POST',
                    });
                    setSelectedItems(items);
                    form.setFieldsValue(
                      formatOrder({
                        items: items.map(item => {
                          const { id, ...rest } = item;
                          return {
                            ...rest,
                            label: item.name,
                            key: item.external_id,
                          };
                        }),
                      })
                    );
                    toggleOrder();
                  }}
                  type="primary"
                >
                  Create Order
                </Button>
              )}
            </span>
          </div>
        }
        placement={isSmallScreen ? 'left' : 'right'}
        closable={false}
        onClose={() => dispatch(toggleCart())}
        width={isSmallScreen ? '90%' : '800px'}
      >
        {orderVisible ? (
          <OrderCreate
            form={form}
            onOk={async (product: Product) => {
              const cart = await fetchAPI('cart/items/delete', {
                payload: {
                  item_ids: selectedItems.map(item => item.id),
                },
                method: 'POST',
              });
              message.success('Create order successfully');
              dispatch(updateCartCount(cart.cart_items.length));
              dispatch(toggleCart());
            }}
          />
        ) : (
          table
        )}
      </Drawer>
    </div>
  );
};
